import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../components/styled/shared/TaskCard.styles";
import { useNavigate, useParams } from "react-router-dom";
import PointComparison from "../components/QualityCheck/PointComparison";
import ZStatsChart from "../components/QualityCheck/ZStatsChart";
import { getAfterStats, getBeforeStats } from "../api/mainAPI";
import { useLoadingStore } from "../Store/store";
import axios from "axios";
import { openDB } from "idb";
import {
  confirmFilteredResult,
  conversionFile,
  createProjectTaskPipeline,
  getConversionJobStatus,
  getFilteredFile,
  getFilteredImage,
  sendZStatsToDB,
} from "../api/ProjectAPI";

const Main = styled.main`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  color: #fff;
  padding: 100px 50px 0px 50px;
  box-sizing: border-box;
  overflow-y: auto;
  max-height: 100vh;
  @media (max-width: 600px) {
    padding: 70px 20px 0px 20px;
  }
`;

const Header = styled.header`
  display: flex;
  gap: 10px;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 20px;
  margin-bottom: 20px;
  h1 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
  }
  p {
    color: rgba(255, 255, 255, 0.33);
    font-size: 15px;
  }
  @media (max-width: 600px) {
    h1 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
  }
`;

const QualityCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding-bottom: 100px;
  @media (max-width: 600px) {
    gap: 30px;
  }
`;

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  text-align: center;

  h2 {
    font-weight: 700;
    color: #fff;
    font-size: 20px;
  }
`;

const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  h2 {
    font-weight: 700;
    color: #fff;
    font-size: 18px;
  }

  .quality-check-item-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .quality-check-item-content-before {
    display: flex;
    justify-content: space-around;
    gap: 20px;
  }
  @media (max-width: 1200px) {
    gap: 10px;
    h2 {
      font-size: 16px;
    }
    .quality-check-item-content-before {
      align-items: center;
      flex-direction: column;
      gap: 30px;
    }
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-around;

  .quality-check-input-content {
    display: flex;
    justify-content: space-around;
    gap: 10px;
    margin-bottom: 20px;
    @media (max-width: 700px) {
      flex-direction: column;
      gap: 30px;
    }
  }

  .quality-check-input-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  label {
    font-size: 18px;
    font-weight: 700;
    @media (max-width: 600px) {
      font-size: 16px;
    }
  }
  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.528);
    margin-bottom: 10px;
    @media (max-width: 600px) {
      font-size: 12px;
      line-height: 1.5;
    }
  }
  .quality-check-input-value {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    display: block;
    background-color: #373737;
    padding: 10px 30px;
    border-radius: 5px;

    text-align: center;
    align-self: flex-start;
    @media (max-width: 600px) {
      font-size: 14px;
      padding: 5px 15px;
    }
  }
  select {
    width: 100%;
    height: 40px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    padding: 10px;
    border-radius: 5px;
    border: 2px solid #373737;
    background-color: transparent;
    margin-bottom: 30px;
    @media (max-width: 600px) {
      width: 250px;
      height: 30px;
      font-size: 13px;
      padding: 5px;
    }
  }
  option {
    color: #121212;
    background-color: #fff;
    font-size: 14px;
    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  input[type="range"] {
    -webkit-appearance: none;
    width: 100%;
    height: 20px;
    background-color: transparent;
    font-size: 16px;
    font-weight: 700;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  /* 트랙 (슬라이더 바) 스타일 */
  input[type="range"]::-webkit-slider-runnable-track {
    height: 6px;
    background: #66cd7c;
    border-radius: 3px;
    @media (max-width: 600px) {
      height: 4px;
    }
  }

  /* 슬라이더 손잡이 스타일 */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 2px solid #66cd7c;
    border-radius: 50%;
    cursor: pointer;
    margin-top: -7px; /* 손잡이 세로 위치 조정 */
    transition: background 0.3s;
    @media (max-width: 600px) {
      width: 15px;
      height: 15px;
      margin-top: -5px;
    }
  }
  input[type="range"]::-webkit-slider-thumb:hover {
    background: #4cafef;
  }

  /* 파이어폭스 전용 */
  input[type="range"]::-moz-range-track {
    height: 6px;
    background: #66cd7c;
    border-radius: 3px;
  }
  input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid #66cd7c;
    border-radius: 50%;
    cursor: pointer;
  }

  .quality-check-input-button-content {
    display: flex;
    justify-content: center;
    gap: 20px;
    button {
      margin: 0;
    }
  }
  @media (max-width: 600px) {
    gap: 5px;
    button {
      margin: 0;
    }
  }
`;

const EPSGWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.528);
    margin-bottom: 10px;
  }
  select {
    width: 300px;
    height: 40px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    padding: 10px;
    border-radius: 5px;
    border: 2px solid #373737;
    background-color: transparent;
    margin-bottom: 30px;
  }
  option {
    color: #121212;
    background-color: #fff;
    font-size: 14px;
  }
  @media (max-width: 600px) {
    h2 {
      font-size: 16px;
      margin-bottom: 5px;
    }
    span {
      font-size: 12px;
    }
    select {
      width: 250px;
      height: 30px;
      font-size: 13px;
      padding: 5px;
    }
  }
`;

const CreateButton = styled(Button)`
  width: 100%;
  max-width: 300px;
  padding: 15px 20px;
  font-size: 15px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

const FilterViewer = styled.div`
  width: 100%;
  height: 100%;

  .filter-viewer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    @media (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
    }
    h2 {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .download-button {
      font-size: 13px;
      padding: 7px 12px;
    }
  }

  .filter-viewer-content {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .download-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
    }
  }
`;

export default function QualityCheckPage() {
  const [neighbors, setNeighbors] = useState(12);
  const [sensitivity, setSensitivity] = useState(2.5);
  const NeighborsValue = [
    8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60,
  ];
  const navigate = useNavigate();
  const [beforeStats, setBeforeStats] = useState({});
  const [afterStats, setAfterStats] = useState({});
  const { isLoading, showLoading, hideLoading } = useLoadingStore();
  const { id } = useParams();
  const [EPSG, setEPSG] = useState();
  const [filteredImage, setFilteredImage] = useState(null);
  const [filteredFile, setFilteredFile] = useState(null);

  useEffect(() => {
    // const getBeforeStatsData = async () => {
    //   const beforeStats = await getBeforeStats();
    //   setBeforeStats(beforeStats);
    // };
    // getBeforeStatsData();
    const beforeStats = JSON.parse(localStorage.getItem("pdal_stats_Z"));
    setBeforeStats(beforeStats);
  }, []);

  const CheckQuality = async () => {
    showLoading("이상치 결측치 검사 중...");

    try {
      // 파일 이름 가져오기
      const bucketName = localStorage.getItem("bucketName");
      const objectName = localStorage.getItem("objectName");
      const outputBucket = localStorage.getItem("outputBucket");
      const outputObject = localStorage.getItem("outputObject");
      const fileName = objectName.split("/").pop();

      // 이상치 필터링 파이프라인
      const pipelineData = {
        pipeline: {
          bucket_name: bucketName,
          object_name: objectName,
          pipeline: [
            {
              type: "readers.las",
              filename: fileName,
            },
            {
              type: "filters.sample",
              radius: 0.1,
            },
            {
              type: "filters.outlier",
              method: "statistical",
              mean_k: Number(neighbors),
              multiplier: Number(sensitivity),
              class: 7,
            },
            {
              type: "filters.expression",
              expression: "Classification != 7",
            },
          ],
          output_bucket: outputBucket,
          output_object: outputObject,
        },
      };

      // 파이프라인 생성 후 통계 데이터 조회
      const response = await createProjectTaskPipeline(pipelineData);
      console.log(response);

      // 필터링된 이미지 조회
      const response2 = await getFilteredImage(outputBucket, outputObject);

      const response3 = await getFilteredFile(outputBucket, outputObject);

      if (response2) {
        setFilteredImage(response2);
      }
      if (response3) {
        setFilteredFile(response3.presignedUrl);
      }

      let zStats = response?.stats?.stats?.statistic?.find(
        (s) => s?.name === "Z",
      );
      // let zStats = { count: 56204927, maximum: 44.28, minimum: 29.37 };

      if (!zStats) {
        console.warn("Z 통계 데이터가 없습니다.");
      } else {
        const result = {
          count: zStats.count,
          maxZ: zStats.maximum,
          minZ: zStats.minimum,
        };
        setAfterStats(result);
      }
    } catch (error) {
      console.error("status:", error.response?.status);
      console.error("server says:", error.response?.data);
    } finally {
      hideLoading();
    }
  };

  // 변환 Job이 완료될 때까지 폴링 (최대 10분, 5초 간격)
  const waitForConversion = async (jobId, label) => {
    const POLL_INTERVAL_MS = 5000;
    const MAX_WAIT_MS = 10 * 60 * 1000;
    const startTime = Date.now();

    while (Date.now() - startTime < MAX_WAIT_MS) {
      const job = await getConversionJobStatus(jobId);
      if (job.status === "COMPLETED") return job;
      if (job.status === "FAILED") {
        throw new Error(
          `${label} 변환 실패: ${job.errorMessage || "알 수 없는 오류"}`,
        );
      }
      // PENDING / PROCESSING → 대기
      await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    }
    throw new Error(`${label} 변환 타임아웃 (10분 초과)`);
  };

  const CreateTask = async () => {
    // 좌표계가 지정되지 않았으면 실행하지 않음
    if (!EPSG || EPSG === "") {
      return;
    }

    const fileId = localStorage.getItem("fileId");
    // 최종 저장
    showLoading("최종 저장 중...");
    const response = await confirmFilteredResult();

    // z 통계 데이터 저장
    showLoading("Z 통계 데이터 저장 중...");
    const response2 = await sendZStatsToDB(afterStats.minZ, fileId);

    // potree 파일 변환 시작 → 완료 대기
    showLoading("Potree 파일 변환 중...");
    const response3 = await conversionFile("POTREE", EPSG);
    await waitForConversion(response3.jobId, "Potree");

    // cesium 파일 변환 시작 → 완료 대기
    showLoading("Cesium 파일 변환 중...");
    const response4 = await conversionFile("CESIUM", EPSG);
    await waitForConversion(response4.jobId, "Cesium");

    hideLoading();
    localStorage.removeItem("fileId");
    navigate(`/project/task/${id}`);
  };
  const EPSGtext = localStorage.getItem("EPSG");
  const EPSGlist = JSON.parse(EPSGtext);
  const coordinateSystems = [
    "EPSG:4326", // WGS84 위경도
    "EPSG:5186", // Korea 2000 Unified CS
    "EPSG:5179", // Korea 2000 / Central Belt

    "EPSG:5181", // Korea 2000 Regional Belt 1
    "EPSG:5182", // Korea 2000 Regional Belt 2
    "EPSG:5183", // Korea 2000 Regional Belt 3
    "EPSG:5184", // Korea 2000 Regional Belt 4
    "EPSG:5185", // Korea 2000 Regional Belt 5
    "EPSG:5187", // Korea 2000 Regional Belt 7

    "EPSG:32651", // UTM Zone 51N
    "EPSG:32652", // UTM Zone 52N

    "EPSG:2096", // Tokyo Datum / Bessel 구좌표 1
    "EPSG:2097", // Tokyo Datum / Bessel 구좌표 2
    "EPSG:2098", // Tokyo Datum / Bessel 구좌표 3
    "EPSG:3857", // WGS 84 / Pseudo-Mercator
    "EPSG:5174", // Korea 2000 / Regional Belt 4
    "EPSG:5175", // Korea 2000 / Regional Belt 5
    "EPSG:5176", // Korea 2000 / Regional Belt 6
    "EPSG:5177", // Korea 2000 / Regional Belt 7
    "EPSG:5178", // Korea 2000 / Regional Belt 8
    "EPSG:32650", // UTM Zone 50N
    "EPSG:26915", // UTM Zone 15N
    "EPSG:32629", // UTM Zone 29N
  ];

  const DownloadFilteredLasFile = useCallback(() => {
    const outputBucket = localStorage.getItem("outputBucket");
    const outputObject = localStorage.getItem("outputObject");

    if (!outputBucket || !outputObject) {
      console.error("다운로드 정보가 없습니다.");
      return;
    }

    // 파일명 추출
    const fileName = outputObject.split("/").pop() || "filtered.las";

    // 백엔드 프록시를 통한 다운로드 (Cross-origin 문제 해결)
    const link = document.createElement("a");
    link.href = `/api/files/minio/download?bucketName=${encodeURIComponent(outputBucket)}&objectName=${encodeURIComponent(outputObject)}&fileName=${encodeURIComponent(fileName)}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return (
    <Main>
      <Header className="project-header">
        <h1>파일 보정</h1>
        <p>파일 보정을 통해 데이터의 품질을 확인할 수 있습니다.</p>
      </Header>
      <QualityCheckContainer>
        <EPSGWrapper>
          <h2>좌표계 입력</h2>
          {/* <span>
            {EPSGlist.isArray
              ? EPSGlist.join(", ")
              : "좌표계 후보를 찾지 못했습니다."}
          </span> */}
          <select
            onChange={(e) => setEPSG(e.target.value)}
            name="EPSG"
            id="EPSG"
          >
            <option value="" key="">
              좌표계 선택
            </option>
            {coordinateSystems.map((system) => (
              <option value={system} key={system}>
                {system}
              </option>
            ))}
          </select>
        </EPSGWrapper>
        <DataWrapper className="quality-check-item">
          <h2>이상치 결측치 검사</h2>
          <div className="quality-check-item-content">
            <div className="quality-check-item-content-before">
              <PointComparison
                beforeStats={beforeStats}
                afterStats={afterStats}
              />
              <ZStatsChart beforeStats={beforeStats} afterStats={afterStats} />
            </div>

            <InputWrapper className="quality-check-input-wrapper">
              <div className="quality-check-input-content">
                <div className="quality-check-input-item">
                  <label htmlFor="quality-check-input">이웃 포인트 수</label>
                  <span>
                    이웃 포인트를 몇 개 참조해 이상치를 판단할지 설정합니다.{" "}
                    <br />
                    (기본값 : 12)
                  </span>
                  <select
                    name="quality-check-input"
                    id="quality-check-input"
                    defaultValue={12}
                    onChange={(e) => setNeighbors(Number(e.target.value))}
                  >
                    {NeighborsValue.map((value) => (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="quality-check-input-item">
                  <label htmlFor="quality-check-input">이상치 민감도</label>
                  <span>
                    값이 낮을수록 더 많은 점을 이상치로 감지합니다.
                    <br />
                    (기본값 : 2.2)
                  </span>
                  <span className="quality-check-input-value">
                    {sensitivity}
                  </span>
                  <input
                    type="range"
                    min="1.0"
                    max="5.0"
                    step="0.1"
                    value={sensitivity}
                    onChange={(e) => setSensitivity(Number(e.target.value))}
                  />
                </div>
              </div>
              {filteredFile && (
                <FilterViewer>
                  <div className="filter-viewer-header">
                    <h2>필터링된 이미지 뷰어</h2>
                    <button
                      className="download-button"
                      onClick={DownloadFilteredLasFile}
                    >
                      필터링된 Las파일 다운로드
                    </button>
                  </div>
                  <div className="filter-viewer-content">
                    {filteredImage && (
                      <img src={filteredImage} alt="필터링된 이미지 뷰어" />
                    )}
                  </div>
                </FilterViewer>
              )}
              <div className="quality-check-input-button-content">
                <Button className="btn-outline" onClick={CheckQuality}>
                  {Object.keys(afterStats).length > 0
                    ? "이상치 재검사"
                    : "이상치 검사"}
                </Button>
                {Object.keys(afterStats).length > 0 && (
                  <CreateButton
                    className="btn-outline"
                    onClick={CreateTask}
                    disabled={!EPSG || EPSG === ""}
                    title={
                      !EPSG || EPSG === ""
                        ? "좌표계를 선택해주세요."
                        : "태스크를 생성합니다."
                    }
                  >
                    태스크 생성
                  </CreateButton>
                )}
              </div>
            </InputWrapper>
          </div>
        </DataWrapper>

        {/* <ResultWrapper className="quality-check-item">
          <h2>보정 후 파일 상태</h2>
          <div className="ImageWrapper"></div>
        </ResultWrapper> */}
      </QualityCheckContainer>
    </Main>
  );
}
